import { Component } from '@angular/core';
import { HvtSection2Dto, ObjectContractDto, LotDto, AcceptanceCriterionDto } from '../../../models/notices/ojeu.notice.models';
import { OjeuEnumsToSelectList, ContractType, FormType, LotSubmission, AcType } from '../../../models/notices/ojeu.notice.enums';
import { SelectableItem } from '../../../models/common/selectableItem';
import { HvtSectionBase } from './hvt.section.base';

@Component({
    selector: 'hvt-s2',
    template: require('./hvt.section.2.component.html')
})
export class HvtS2Component extends HvtSectionBase<HvtSection2Dto> {
    hvtS2: HvtSection2Dto;

    contractTypes: Array<SelectableItem<ContractType>>;

    constructor() {
        super();
        this.contractTypes = OjeuEnumsToSelectList.getContractTypeList();
    }

    populate(hvtS2: HvtSection2Dto, formType: FormType) {
        this.hvtS2 = hvtS2;
        this.formType = formType;
    }

    clear() {
        this.hvtS2 = null;
        this.formType = null;
    }

    getContractType(objContract: ObjectContractDto) {
        return this.contractTypes.find((c: SelectableItem<ContractType>) => {
            return c.value === objContract.contractType;
        }).text;
    }

    showLotsInformation(objContract: ObjectContractDto) {
        //should show for: 365805 (F24)
        return objContract.submissionType !== LotSubmission.NotSplit || this.formType !== FormType.F242014;
    }

    getLotDivisionText(objContract: ObjectContractDto) {
        return objContract.submissionType === LotSubmission.NotSplit ? 'no' : 'yes';
    }

    getLotSubmissionText(objContract: ObjectContractDto) {
        switch (objContract.submissionType) {
            case LotSubmission.AllLots:
                {
                    return 'Tenders may be submitted for all lots';
                }
            case LotSubmission.OneOnly:
                {
                    return 'Tenders may be submitted for one lot only';
                }
            case LotSubmission.MaxNumber:
                {
                    return `Tenders may be submitted for a maximum number of lots: ${objContract.maxSubmissionLots}`;
                }
            default:
                {
                    return null;
                }
        }
    }

    showSectionII1s5(objContract: ObjectContractDto) {
        return !this.hvtS2.isContractAward &&
            this.formType !== FormType.F032014 &&
            this.formType !== FormType.F152014 &&
            this.formType !== FormType.F062014;
    }

    showSectionII1s7(objContract: ObjectContractDto) {
        return (this.hvtS2.isContractAward || this.isF03() || this.formType === FormType.F152014 || this.formType === FormType.F062014) && (objContract.value || objContract.minValue || objContract.maxValue);
    }

    titleSectionII1s7(objContract: ObjectContractDto) {
        return `Total value of the procurement (excluding VAT) ${objContract.agreedToPublish !== null
            ? `(Agree to publish? ${objContract.agreedToPublish ? 'yes' : 'no'})`
            : ''}`;
    }

    showSectionII2s5(lot: LotDto, objContract: ObjectContractDto) {
        // F01 Logic?:
        // Show if there is lot division - all lots (302182, 312913)
        // or if the ac are in the procurement doc - 362133, 362140, 370446
        // Do not show if there is no lot division (283876, 315300, 315301, 315302)
        // Do not show if there is lot division and... (330843)
        // not all lots? - going to try this one 06/08/2018
        // ctype == works?
        // renewal description exists?

        if (this.formType === FormType.F012014) {
            if (objContract.submissionType !== LotSubmission.AllLots && !lot.acInProcurementDocs) {
                return false;
            }
        }

        return this.formType === FormType.F152014 || this.formType === FormType.F012014 ||
            lot.acInProcurementDocs ||
            (lot.acceptanceCriteria && lot.acceptanceCriteria.length > 0);
    }

    showSectionII2s5CriteriaBelow(lot: LotDto) {
        return this.formType === FormType.F022014 && lot.acceptanceCriteria.length > 0 && !lot.ec200981Directive;
    }

    showSectionII2s6(lot: LotDto, objContract: ObjectContractDto) {
        // Show if there are acceptance criteria (302182, 313173)

        // F01 Logic?:
        // Show if there is lot division - all lots? (312913 = all lots - SHOWN; 330843 = not all lots - NOT SHOWN)
        // or if the ac are in the procurement doc - 362133, 362140, 370446
        // Do not show if there is no lot division or acceptance criteria (283876, 315300, 315301, 315302)
        if (this.formType === FormType.F012014) {
            if (objContract.submissionType !== LotSubmission.AllLots && !lot.acInProcurementDocs) {
                return false;
            }

            return true;
        }

        if (this.formType === FormType.F232014) {
            //333131
            return true;
        }

        if (this.formType === FormType.F212014) {
            // Do not show for F21?
            // 359040, 363164
            return false;
        }

        return !this.isF03() && this.formType !== FormType.F062014 && !lot.eu201424Directive &&
            (lot.value ||
                lot.acInProcurementDocs ||
                (lot.acceptanceCriteria && lot.acceptanceCriteria.length > 0));
    }

    showSectionII2s7(lot: LotDto) {
        // F01 logic (fucking yay - more fucking F01 bullshit edge cases)
        // NOT SHOWN: 216055, 261629, 330843
        // SHOWN: 279457
        if (this.formType === FormType.F012014 &&
            lot.renewal !== null &&
            lot.renewalDescription !== null &&
            lot.duration === 0) {
            return false;
        }

        if (this.formType === FormType.F232014) {
            //333131
            return true;
        }

        return lot.renewal !== null || lot.jsStartDate || lot.jsEndDate || lot.duration || lot.renewalDescription;
    }

    showSectionII2s9(lot: LotDto, objContract: ObjectContractDto) {
        // If envisaged candidates/max/min candidates not populated, show if no renewal?
        // Incorrect - 283841 should not show and has no renewal.
        // new theory: do not show if objContract.contractType is SERVICES
        // SHOWS FOR: 283942 (WORKS), 283946 (WORKS), 304532 (WORKS), 304526 (WORKS), 302231 (SUPPLIES) - NO_RENEWAL, 325626 - RENEWAL and envisaged candidates
        // DOES NOT SHOW FOR: 283841 (SERVICES) - RENEWAL, 323123 (SERVICES) - NO RENEWAL
        return (!(this.formType === FormType.F012014 ||
            this.formType === FormType.F032014 ||
            this.formType === FormType.F042014 ||
            this.formType === FormType.F152014 ||
            this.formType === FormType.F212014 ||
            this.formType === FormType.F242014 ||
            this.formType === FormType.F062014) &&
            objContract.contractType !== ContractType.Services) ||
            lot.envisagedCandidates !== null ||
            lot.envisagedMinCandidates !== null ||
            lot.envisagedMaxCandidates !== null;
    }

    showSectionII2s10(lot: LotDto) {
        return lot.variantsAccepted !== null ||
            //F01 logic:
            //variants accepted null
            //AND duration/start&end? or no eu related program - not certain here
            //283876 - NOT SHOW
            //302182, 312913, 312916 - SHOW
            (this.formType === FormType.F012014 && lot.variantsAccepted === null && lot.relatedEuProgram === false);
    }

    showSectionII2s11(lot: LotDto) {
        return lot.hasOptions !== null ||
            //F01 logic:
            //variants accepted null
            //AND duration/start&end? or no eu related program - not certain here
            //283876 - NOT SHOW
            //312913, 312916 - SHOW;
            (this.formType === FormType.F012014 && lot.hasOptions === null && lot.relatedEuProgram === false);
    }

    showSectionII2s12() {
        return !(this.formType === FormType.F012014 ||
            this.formType === FormType.F032014 ||
            this.formType === FormType.F042014 ||
            this.formType === FormType.F152014 ||
            this.formType === FormType.F212014 ||
            this.formType === FormType.F242014 ||
            this.formType === FormType.F062014);
    }

    showSectionII2s13(lot: LotDto) {
        return lot.relatedEuProgram !== null;
    }

    showSectionII3(objContract: ObjectContractDto) {
        // SHOW: 325480
        // DO NOT SHOW: 312913
        return objContract.jsPublicationNoticeDate;
    }

    isF02() {
        return this.formType === FormType.F022014;
    }

    isF03() {
        return this.formType === FormType.F032014;
    }

    isF23() {
        return this.formType === FormType.F232014;
    }

    isF24() {
        return this.formType === FormType.F242014;
    }

    getQualityCriteria(lot: LotDto) {
        return lot.acceptanceCriteria.filter((ac: AcceptanceCriterionDto) => {
            return ac.type === AcType.Quality;
        });
    }

    getPriceCriteria(lot: LotDto) {
        return lot.acceptanceCriteria.filter((ac: AcceptanceCriterionDto) => {
            return ac.type === AcType.Price;
        });
    }

    getCostCriteria(lot: LotDto) {
        return lot.acceptanceCriteria.filter((ac: AcceptanceCriterionDto) => {
            return ac.type === AcType.Cost;
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/notices/ojeu/hvt.section.2.component.ts